<template>
  <div class="text-panel fill-height d-flex flex-column">

    <!-- TEXTO -->
    <v-row dense>
      <v-col cols="12">
        <v-textarea
          v-model="textSelected"
          label="Texto"
          rows="2"
          auto-grow
          dense
          outlined
          hide-details
          class="text-input"
        />
      </v-col>
    </v-row>

    <!-- TAMAÑO -->
    <v-row dense align="center" class="control-row">
      <v-col cols="4" class="control-label">
        Tamaño
      </v-col>

      <v-col cols="6">
        <v-slider
          v-model="sizeSelected"
          min="8"
          max="72"
          step="1"
          dense
          hide-details
          class="custom-slider"
        />
      </v-col>

      <v-col cols="2">
        <v-text-field
          v-model.number="sizeSelected"
          type="number"
          min="8"
          max="72"
          dense
          hide-details
          solo
          flat
          class="number-box"
        />
      </v-col>
    </v-row>

    <!-- ROTACIÓN -->
    <v-row dense align="center" class="control-row">
      <v-col cols="4" class="control-label">
        Rotación
      </v-col>

      <v-col cols="6">
        <v-slider
          v-model="angleSelected"
          min="0"
          max="360"
          step="1"
          dense
          hide-details
          class="custom-slider"
        />
      </v-col>

      <v-col cols="2">
        <v-text-field
          v-model.number="angleSelected"
          type="number"
          min="0"
          max="360"
          dense
          hide-details
          solo
          flat
          class="number-box"
        />
      </v-col>
    </v-row>

    <!-- COLOR -->
    <v-row dense align="center" class="control-row">
      <v-col cols="4" class="control-label">
        Color
      </v-col>

      <v-col cols="4" class="d-flex align-center">

        <!-- MENU -->
        <v-menu
          v-model="colorMenu"
          offset-y
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ props }">
            <v-btn
              v-bind="props"
              icon
              size="small"
              elevation="0"
              class="palette-btn"
              @click="colorMenu = !colorMenu"
            >
              <v-icon size="18" color="white">mdi-palette</v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-color-picker
              v-model="colorSelected"
              hide-inputs
              mode="hexa"
            />
          </v-card>
        </v-menu>

        <!-- Preview -->
        <div
          class="color-preview"
          :style="{ backgroundColor: colorSelected }"
        ></div>

      </v-col>

      <v-col class="d-flex justify-end">
        <v-btn
          small
          elevation="0"
          @click="paint"
        >
          Pintar
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { hexToRgba } from '@/helpers/utils/colorUtils'

export default {
  data: () => ({
    sizeSelected: 16,
    angleSelected: 0,
    textSelected: 'Texto',
    colorMenu: false,
    colorSelected: '#000000'
  }),

  methods: {
    paint() {
      const event = {
        function: 'text',
        text: this.textSelected,
        size: this.sizeSelected,
        angle: this.angleSelected,
        color: hexToRgba(this.colorSelected)
      }
      this.$emit('paint', event)
      this.textSelected = 'Texto'
    }
  }
}
</script>

<style scoped>
.text-panel {
  padding: 10px 6px;
  color: white;
  height: 80%;
}

.control-row {
  margin-top: 6px;
}

.text-input >>> .v-input__control {
  background: rgba(255, 255, 255, 0.08);
  border-radius: 6px;
}

.text-input >>> textarea {
  color: white;
  font-size: 13px;
}

.custom-slider {
  margin-top: 6px;
  margin-left: 6px;
}

/* Slider blanco sobre fondo oscuro */
.custom-slider >>> .v-slider__track-background {
  background-color: rgba(255,255,255,0.2);
}

.custom-slider >>> .v-slider__track-fill {
  background-color: white;
}

.custom-slider >>> .v-slider__thumb {
  background-color: white;
}

/* Botón paleta */
.palette-btn {
  background: rgba(255,255,255,0.08);
  border-radius: 6px;
}

/* Preview color */
.color-preview {
  width: 18px;
  height: 18px;
  border-radius: 4px;
  margin-left: 8px;
  border: 1px solid rgba(255,255,255,0.4);
}

.palette-btn {
  background: rgba(255,255,255,0.15);
  backdrop-filter: blur(4px);
  border-radius: 8px;
}

.color-preview {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  margin-left: 8px;
  border: 1px solid rgba(255,255,255,0.5);
}

.number-box .v-input__control {
  background: rgba(255,255,255,0.15);
  border-radius: 6px;
  padding: 0 4px;
}

.number-box input {
  text-align: center;
  color: white;
  font-size: 13px;
  font-weight: 500;
}

.control-label {
  font-size: 13px;
  font-weight: 500;
  color: white;
}

</style>
